const TagsService = {
  getTags: async () => {
    const { data } = await ovpFetch('/tags');
    return data;
  },
};

// eslint-disable-next-line
export { TagsService };
